import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7tyz7uw3es: FaireBrandEntity = {
  token: "b_7tyz7uw3es",
  type: "brand",
  name: "The Honey and Bro Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/de43d72087e4da53e4d65ab2a70737b348b2af30ecc8a24e796b1a1ac7abc4cf.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/26cbcf5262bfd648d2f854d025a66fe04e1eea346b0e3b847ad567418f41aad2.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/de43d72087e4da53e4d65ab2a70737b348b2af30ecc8a24e796b1a1ac7abc4cf.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/26cbcf5262bfd648d2f854d025a66fe04e1eea346b0e3b847ad567418f41aad2.jpeg",
  location: "Pitman, NJ, USA",
  minimumOrderDollars: 50,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "Two moms. Eight kids between them. One mission: dress babies in the softest, cutest clothes that actually last.\nThe Honey and Bro Co. is a children's boutique specializing in premium bamboo pajamas, organic cotton essentials, and curated seasonal collections for newborns through 5T. We're known for our obsession with fabric quality (if it's not butter-soft, it doesn't make the cut), original prints, and a loyal customer base of 1,000+ families.\nComing soon: our own line of custom TENCEL™ Modal and bamboo sleepwear - designed in-house, sustainably made, impossibly soft.\nBased in New Jersey. Mom-owned.\nZero shortcuts.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:51.800Z",
    importedBy: "entity-db-cli",
  },
};
